// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"1621af8d","614":"ee324ffa","2450":"83f9c846","2474":"e50f46ed","3662":"bfc6e2f6","3725":"825ba280","6507":"63c205f9","7062":"e738bf0a","7978":"5122c147"}[chunkId] + ".chunk.css";
};